<!-- eslint-disable vue/block-tag-newline -->
<script setup lang="ts">
import ResonantEd from './ResonantEd/ResonantEd.vue';
</script>
<!-- eslint-enable vue/block-tag-newline -->

<template>
  <div class="w-full">
    <ResonantEd />
  </div>
</template>
